import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';

const ReactNotificationComponent = ({
  title,
  body,
  showToast,
  setShowToast,
}) => {
  const generateToastId = () => {
    return `${title?.split(' ')?.[0] ?? ''}_${Date.now()}`;
  };

  const Display = () => (
    <div className="content-body">
      <h4>{title}</h4>
      <p>{body}</p>
    </div>
  );

  useEffect(() => {
    if (showToast) {
      toast.info(<Display />, {
        toastId: generateToastId(),
        autoClose: 6000,
        position: 'top-right',
        hideProgressBar: true, // Hide the progress bar
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        onClose: () => setShowToast?.(false),
      });
    }
  }, [showToast, title, body]);

  return (
    <StyledToastContainer
      newestOnTop
      limit={5}
      hideProgressBar={true} // Hide progress bar at container level
      closeButton={
        <>
          <span
            onClick={() => setShowToast?.(false)}
            className="Toast-close-button k-icon k-font-icon k-i-close"
          ></span>
        </>
      }
    />
  );
};

ReactNotificationComponent.defaultProps = {
  title: 'This is title',
  body: 'Some body',
};

ReactNotificationComponent.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  showToast: PropTypes.bool,
  setShowToast: PropTypes.func,
};

const StyledToastContainer = styled(ToastContainer)`
  min-width: 350px;

  .Toastify__toast {
    background: ${p => p.theme.white};
    border-radius: 22px;
    position: relative;
  }

  .Toast-close-button {
    position: absolute;
    top: 8px;
    right: 10px;
    cursor: pointer;
    font-size: 16px;
    color: ${p => p.theme.black};
  }

  .Toastify__toast-icon {
    margin: 12px 10px auto 0;
  }

  .content-body {
    h4 {
      color: ${p => p.theme.black};
      text-transform: capitalize;
      font-family: 'open sans';
      font-size: 18px;
      margin: 8px 0 10px 0;
    }
    p {
      color: ${p => p.theme.black};
      text-transform: capitalize;
      font-family: 'open sans';
      font-size: 14px;
    }
  }
`;

export default ReactNotificationComponent;
